<template>
  <div class="flex flex-col">
    <NText variant="body" weight="regular" class="block mb-8">
      {{ t('symbol.broker_change_cancel_request_message') }}
    </NText>

    <div class="flex w-full justify-center">
      <NButton
        variant="plain"
        color="gray"
        class="ml-2 flex-1"
        @click="emit('close')"
      >
        {{ t('common.cancel') }}
      </NButton>

      <NButton
        variant="fill"
        color="red"
        class="flex-1"
        :disabled="isDeletingBrokerChangeRequest"
        :loading="isDeletingBrokerChangeRequest"
        @click="emit('delete', props.requestId)"
      >
        {{ t('common.cancelRequest') }}
      </NButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

type DeleteBrokerChangeFormEmitType = {
  (e: 'close'): void;
  (e: 'delete', requestId: number): void;
};

type DeleteBrokerChangeFormPropsType = {
  requestId: number;
  isDeletingBrokerChangeRequest: boolean;
};

const emit = defineEmits<DeleteBrokerChangeFormEmitType>();

const props = defineProps<DeleteBrokerChangeFormPropsType>();

const { t } = useI18n();
</script>
